import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Check, Sparkles, ArrowRight, CreditCard, TrendingDown } from "lucide-react";

export default function Subscribe() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState("");

  useEffect(() => {
    api.get("/payments/config").then((r) => setConfig(r.data));
  }, []);

  const startCheckout = async (lookup_key) => {
    setLoading(lookup_key);
    try {
      const r = await api.post("/payments/checkout", {
        lookup_key,
        origin_url: window.location.origin,
      });
      window.location.href = r.data.checkout_url;
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore checkout");
      setLoading("");
    }
  };

  if (!config) return <div className="max-w-4xl mx-auto p-8 text-[#A0A0AB]">Caricamento...</div>;
  if (!config.enabled) return (
    <div className="max-w-3xl mx-auto p-8">
      <h1 className="font-display text-4xl font-black uppercase mb-4">Abbonamenti non attivi</h1>
      <p className="text-[#A0A0AB]">L'amministratore non ha ancora configurato Stripe.</p>
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="text-[10px] uppercase tracking-[0.3em] text-[#E2FF31] mb-2 flex items-center gap-2">
        <Sparkles className="w-3 h-3" /> Sblocca il tuo potenziale
      </div>
      <h1 className="font-display text-5xl sm:text-6xl font-black uppercase tracking-tighter leading-[0.9] mb-3">
        Diventa <span className="text-[#FF3B30]">Pro</span>
      </h1>
      <p className="text-[#A0A0AB] mb-10 max-w-xl">
        Sblocca l'AI Coach illimitato, programmi settimanali su misura e progressione automatica. Cancellabile in qualsiasi momento.
      </p>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {config.plans.map((p) => {
          const featured = p.lookup_key === "fc_pro_yearly";
          return (
            <div
              key={p.lookup_key}
              data-testid={`plan-${p.lookup_key}`}
              className={`relative overflow-hidden p-6 transition-all group border ${
                featured
                  ? "border-[#E2FF31] bg-gradient-to-br from-[#141419] to-[#0B0B0F]"
                  : "border-[#2A2A35] hover:border-[#FF3B30]"
              }`}
            >
              {featured && (
                <div className="absolute top-0 right-0 bg-[#E2FF31] text-black text-[10px] font-black uppercase tracking-[0.2em] px-3 py-1 flex items-center gap-1" data-testid="yearly-savings-badge">
                  <TrendingDown className="w-3 h-3" strokeWidth={3} /> {p.savings_badge}
                </div>
              )}
              <div
                className={`absolute -top-8 -right-8 w-32 h-32 rounded-full blur-2xl transition-all ${
                  featured ? "bg-[#E2FF31]/10 group-hover:bg-[#E2FF31]/20" : "bg-[#FF3B30]/10 group-hover:bg-[#FF3B30]/20"
                }`}
              />
              <div className="relative">
                <div className="text-[10px] uppercase tracking-[0.3em] text-[#A0A0AB] mb-2">
                  {p.interval === "year" ? "Piano Annuale" : "Piano Mensile"}
                </div>
                <div className="font-display text-3xl font-black uppercase leading-tight mb-2">
                  {p.name}
                </div>
                <div
                  className={`font-display text-5xl font-black mb-1 ${
                    featured ? "text-[#E2FF31]" : "text-[#FF3B30]"
                  }`}
                >
                  {p.price_display}
                </div>
                <div className="text-xs text-[#A0A0AB] mb-6">{p.billed_note}</div>
                <ul className="space-y-2 mb-8">
                  {p.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm">
                      <Check
                        className={`w-4 h-4 flex-shrink-0 mt-0.5 ${
                          featured ? "text-[#E2FF31]" : "text-[#FF3B30]"
                        }`}
                        strokeWidth={3}
                      />
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button
                  onClick={() => startCheckout(p.lookup_key)}
                  disabled={!!loading}
                  data-testid={`sub-btn-${p.lookup_key}`}
                  className={`w-full font-bold uppercase tracking-widest py-4 transition-all flex items-center justify-center gap-2 disabled:opacity-40 ${
                    featured
                      ? "bg-[#E2FF31] text-black hover:bg-[#c9e02c]"
                      : "bg-[#FF3B30] text-white hover:bg-[#e02e24]"
                  }`}
                >
                  <CreditCard className="w-4 h-4" />
                  {loading === p.lookup_key ? "Attendi..." : featured ? "Passa all'annuale" : "Inizia ora"}
                  <ArrowRight className="w-4 h-4" />
                </button>
                <div className="text-[10px] uppercase tracking-widest text-[#A0A0AB] mt-3 text-center">
                  Cancellabile in qualsiasi momento
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 text-xs text-[#A0A0AB] text-center">
        Pagamento sicuro gestito da Stripe. Test mode — carta prova: 4242 4242 4242 4242, qualsiasi data futura, qualsiasi CVC.
      </div>
    </div>
  );
}
